<template>
  <div
    v-if="(images && images.length > 0) || (texts && texts.length > 0) || $ceres.isShopBuilder"
    class="gpsr-safety-info"
  >
    <div
      class="gpsr-title"
      v-text="$translate('GPSR::Template.safetyInfoTitle')"
    />
    <div
      v-if="images && images.length > 0"
      class="images"
    >
      <lazy-img
        v-for="(image, imageIndex) in images"
        :key="`image-${imageIndex}`"
        :image-url="image"
        :alt="currentVariation.name"
        :title="currentVariation.name"
      />
    </div>
    <div
      v-if="texts && texts.length > 0"
      class="texts"
    >
      <div
        v-for="(text, textIndex) in texts"
        :key="`text-${textIndex}`"
        class="text-item"
        v-html="text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GpsrSafetyInfo',

  inject: {
    itemId: {
      default: null
    }
  },

  props: {
    imageIds: {
      type: String,
      default: ''
    },
    textIds: {
      type: String,
      default: ''
    }
  },

  computed: {
    currentVariation () {
      return this.$store.getters[`${this.itemId}/currentItemVariation`];
    },

    images () {
      return this.getVariationDataByIds(this.imageIds);
    },

    texts () {
      return this.getVariationDataByIds(this.textIds);
    }
  },

  methods: {
    getVariationDataByIds (ids) {
      return ids.split(',').map((imageId) => {
        const variationPropertyId = imageId.trim();
        const property = this.getVariationPropertyById(variationPropertyId);

        if (!property) {
          return false;
        }

        if (property.cast == 'multiSelection') {
          if (property.values && property.values.length > 0) {
            return property.values.map((propVal) => {
              return propVal.value;
            });
          }
        } else if (property.cast == 'file') {
          return encodeURI(this.$options.filters.propertyFileUrl(property.values.value));
        }

        return property.values.value;
      }).flat(Infinity).filter(Boolean);
    },
    getVariationPropertyById (id) {
      let resultProperty = false;
      if (this.currentVariation && this.currentVariation.variationProperties && this.currentVariation.variationProperties.length > 0) {
        this.currentVariation.variationProperties.forEach((propertyGroup) => {
          if (propertyGroup.properties) {
            const property = propertyGroup.properties.find(prop => prop.id == id);
            if (property) {
              resultProperty = property;
            }
          }
        });
      }
      return resultProperty;
    }
  }
};
</script>
